import { render, staticRenderFns } from "./AddActivityLmsModal.vue?vue&type=template&id=231a800c&"
import script from "./AddActivityLmsModal.vue?vue&type=script&lang=js&"
export * from "./AddActivityLmsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports